<template>
  <div>
    <head-nav-bar title="结账" :fixed="true" />
    <div class="mt-header-nav">
      <van-row style="padding: 5px 10px;">
        <van-col span="24" style="margin:10px 0">
          结账桌台：{{ tbaleNames }}
        </van-col>
        <van-col span="12" style="color: #999999;">
          消费金额：<span style="color:red"
            >&yen;
            {{ orderInfo.TotalAmount }}
          </span>
        </van-col>
        <van-col span="12" style="color: #999999;">
          已收金额：<span style="color:red">
            &yen;{{ orderInfo.PayAmount }}
          </span>
        </van-col>
      </van-row>

      <moneyInput label="金额" placeholder="金额" v-model="form.Money" />
      <div class="btn-operate">
        <span>
          <span v-if="Number(orderInfo.Discount) > 0">
            <van-button type="warning" size="small" @click="cancelDiscount"
              >取消折扣</van-button
            >
            当前：{{ orderInfo.Discount }} 折
          </span>
          <span v-else
            ><van-button type="info" size="small" @click="addDiscount"
              >折扣</van-button
            ></span
          >
        </span>
        <span>
          <span v-if="Math.abs(orderInfo.FreeRemnantAmount) > 0">
            抹零金额：<span style="color:#f00;margin-right:10px">
              ￥{{ orderInfo.FreeRemnantAmount }}</span
            >
            <van-button type="warning" s size="small" @click="cancelFreeRemnant"
              >取消抹零</van-button
            >
          </span>
          <span v-else>
            <van-button type="primary" s size="small" @click="addFreeRemnant"
              >抹零</van-button
            >
          </span>
        </span>
      </div>
      <van-cell-group class="settle-box">
        <fromSelect
          label="付款方式"
          v-model="form.AccountItemId"
          :required="true"
          :columns="payItems"
          @change="changeItem"
        />

        <van-field v-model="form.TargetName" label="客户会员" disabled />
        <van-field
          v-model="form.BillNo"
          label="单据号"
          placeholder="请输入单据号"
          clearable
        />
        <van-field
          v-model="form.Remark"
          rows="3"
          autosize
          type="textarea"
          label="备注信息"
          placeholder="请输入备注信息"
          clearable
        />
        <div class="settle-method">
          <label>结账方式</label>
          <van-radio-group v-model="isOnlyPayment" direction="horizontal">
            <van-radio name="1">付款并结账</van-radio>
            <van-radio name="2">仅付款</van-radio>
          </van-radio-group>
        </div>
      </van-cell-group>
      <div class="submit">
        <van-button
          type="info"
          round
          size="large"
          :loading="loading"
          @click="onSubmit"
        >
          确认
        </van-button>
      </div>
    </div>
    <SelectRoom
      ref="SelectRoom"
      height="90%"
      @submit="getRoomInfo"
    ></SelectRoom>
    <van-dialog
      v-model="showDiscount"
      title="添加折扣"
      @confirm="confirmDiscount"
      show-cancel-button
    >
      <div class="discount-sec">
        <label> 折扣 </label>
        <van-stepper
          v-model="discount"
          :min="0"
          :max="10"
          @focus="onFocus"
          @plus="onPlus"
          @minus="onMinus"
          :decimal-length="2"
          @change="changeDiscount"
        />
      </div>
      <van-field
        v-model="amountAfterDiscount"
        type="number"
        label="折后金额"
        clearable
        @input="changeAmount"
      />
    </van-dialog>
    <van-dialog
      v-model="showFree"
      title="添加抹零"
      @confirm="confirmFree"
      :beforeClose="beforeClose"
      show-cancel-button
    >
      <div class="free-sec"><label> 抹零金额 </label>{{ freeAmount }}</div>
      <van-field
        v-model="moneyAfterFreeRemnant"
        type="number"
        label="抹零后金额"
        clearable
      />
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  Row,
  Col,
  Radio,
  RadioGroup,
  Button,
  Notify,
  Cell,
  CellGroup,
  Field,
  Dialog,
  Stepper,
} from "vant";
import moneyInput from "../../components/moneyInput";
import fromSelect from "../../components/form-select";
import selectMember from "@/components/select-member/function.js";
import MemberPasswordVerify from "@/components/member-password-verify/function.js";
import selectUser from "@/components/select-user/function.js";
import { getSelectData } from "@/api/common";
import restaurantApi from "@/api/restaurant.js";
import restaurantManageApi from "@/api/restaurantManage.js";
import SelectRoom from "./SelectRoom.vue";
import { accSub } from "@/utils/common";
export default {
  name: "OrderCashDesk",
  components: {
    moneyInput,
    [Stepper.name]: Stepper,
    [Dialog.Component.name]: Dialog.Component,
    fromSelect,
    SelectRoom,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      loading: false,
      orderId: null,
      orderInfo: {},
      payMoney: "",
      selectRoomArr: [],
      payItems: [],
      tableIds: [],
      isOnlyPayment: "1",
      payType: "",
      form: {
        AccountItemId: "",
        AccountItemName: "",
        Money: "0",
        BillNo: "",
        Remark: "",
        TargetName: "",
        TableId: "",
      },
      showDiscount: false,
      discount: 0,
      amountAfterDiscount: 0,
      isChangeDiscount: false,
      tbaleNames: "",
      showFree: false,
      moneyAfterFreeRemnant: 0,
      resConfig: {},
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.orderId;
    this.tableIds = this.$route.query.tableIds.split(",");
    getSelectData({ Types: "restaurantpayway" }).then(res => {
      this.payItems = res.Data.restaurantpayway.filter(
        item =>
          !(
            item &&
            item.Data &&
            ((item.Data.Attributes & 2097152) > 0 ||
              ((item.Data.Attributes & 8192) > 0 &&
                item.Text.includes("会员卡")))
          ),
      );
      this.init();
    });
    restaurantManageApi.getRestaurantConfig({}).then(res => {
      this.resConfig = res.Data;
    });
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
    freeAmount() {
      if (Number(this.amountAfterDiscount) >= 0) {
        return accSub(this.moneyAfterFreeRemnant, this.orderInfo.UnPayAmount);
      }
      return 0;
    },
  },
  watch: {},
  methods: {
    init() {
      restaurantApi.getOrderDetail({ id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        this.tbaleNames = res.Data.DishTables.filter(el =>
          this.tableIds.includes(el.TableId),
        )
          .map(p => p.TableName)
          .join(",");
        if (this.orderInfo.MemberCardId) {
          this.payType = 1;
          this.form.MemberCardId = this.orderInfo.MemberCardId;
          this.form.MemberCardNo = this.orderInfo.MemberName;
          this.form.TargetName = this.orderInfo.MemberName;
          let result = this.payItems.find(
            item =>
              (item.Data &&
                item.Data.Attributes &&
                item.Data.Attributes & 4096) > 0,
          );
          this.form.AccountItemId = result ? result.Id : "";
        }
        this.form.Money = String(this.orderInfo.UnPayAmount);
        this.form.TableId = this.tableIds[0];
        this.form.BillNo = this.orderInfo.DishTables.find(
          el => el.TableId == this.tableIds[0],
        ).TableName;
        this.form.TableName = this.form.BillNo;
      });
    },
    addDiscount() {
      this.showDiscount = true;
      this.discount = 0;
      this.amountAfterDiscount = this.orderInfo.UnPayAmount;
    },
    onFocus(e) {
      this.isChangeDiscount = true;
      e.currentTarget.select();
    },
    onPlus() {
      this.isChangeDiscount = true;
    },
    onMinus() {
      this.isChangeDiscount = true;
    },
    changeDiscount(/*val, detail*/) {
      if (this.isChangeDiscount) {
        const json = {
          Id: this.orderId,
          IsPreview: true,
          Discount: this.discount ? this.discount : 0,
        };
        restaurantManageApi.discount(json).then(res => {
          this.amountAfterDiscount = res.Data.FinalAmount;
        });
      }
    },
    changeAmount(/*val*/) {
      const json = {
        Id: this.orderId,
        IsPreview: true,
        AmountAfterDiscount: this.amountAfterDiscount,
      };
      restaurantManageApi.discount(json).then(res => {
        this.discount = res.Data.Discount;
        this.isChangeDiscount = false;
      });
    },
    confirmDiscount() {
      setTimeout(() => {
        restaurantManageApi
          .discount({
            Id: this.orderId,
            AmountAfterDiscount: this.amountAfterDiscount,
            IsPreview: false,
          })
          .then(() => {
            Notify({ type: "success", message: "操作成功" });
            this.init();
          });
      }, 150);
    },
    cancelDiscount() {
      const _this = this;
      Dialog.confirm({
        title: "确定取消折扣吗？",
      }).then(() => {
        restaurantManageApi
          .discount({
            Id: _this.orderId,
            Discount: 0,
            IsPreview: false,
          })
          .then(() => {
            Notify({ type: "success", message: "操作成功" });
            _this.init();
          });
      });
    },
    addFreeRemnant() {
      this.showFree = true;
      this.moneyAfterFreeRemnant = this.orderInfo.UnPayAmount;
    },
    cancelFreeRemnant() {
      const _this = this;
      Dialog.confirm({
        title: "确定取消抹零吗？",
      }).then(() => {
        restaurantManageApi
          .cancelFreeRemnant({
            Id: _this.orderId,
          })
          .then(() => {
            Notify({ type: "success", message: "操作成功" });
            _this.init();
          });
      });
    },
    beforeClose(action, done) {
      if (
        Number(this.freeAmount) < 0 &&
        Number(Math.abs(this.freeAmount)) > Number(this.resConfig.LimitValue) &&
        action == "confirm"
      ) {
        done(false);
      } else if (
        Number(Math.abs(this.freeAmount)) >
          Number(this.resConfig.RemindValue) &&
        action == "confirm"
      ) {
        done(false);
      } else {
        done();
      }
    },
    confirmFree() {
      if (
        Number(this.freeAmount) < 0 &&
        Number(Math.abs(this.freeAmount)) > Number(this.resConfig.LimitValue)
      ) {
        Notify("抹零金额不能超过最大限制【" + this.resConfig.LimitValue + "】");
        return false;
      } else if (
        Number(Math.abs(this.freeAmount)) > Number(this.resConfig.RemindValue)
      ) {
        const _this = this;
        Dialog.confirm({
          title: "超额提醒",
          message: "您的抹零金额为【" + this.freeAmount + "】，是否确定抹零？",
        })
          .then(() => {
            _this.submitFree();
          })
          .catch(() => {
            _this.moneyAfterFreeRemnant = _this.orderInfo.UnPayAmount;
          });
      } else {
        this.submitFree();
      }
      // this.showFree = false;
    },
    submitFree() {
      restaurantManageApi
        .freeRemnant({
          OrderId: this.orderId,
          MoneyAfterFreeRemnant: this.moneyAfterFreeRemnant,
        })
        .then(() => {
          this.showFree = false;
          this.init();
        });
    },
    //选择支付方式change
    changeItem(value) {
      let item = this.payItems.find(p => p.Id == value.Id);
      if (item && item.Data && item.Data.Attributes) {
        if ((item.Data.Attributes & 4096) > 0) {
          this.payType = 1;
        } else if ((item.Data.Attributes & 2) > 0) {
          this.payType = 2;
        } else if ((item.Data.Attributes & 64) > 0) {
          this.payType = 3;
        } else {
          this.payType = 0;
        }
        this.onSwitchItem(this.payType);
      }
    },
    onSwitchItem(value) {
      switch (value) {
        case 1: //会员卡
          this.onSelectMember();
          break;
        case 2: //挂账
          this.onSelectCustomer();
          break;
        case 3:
          //转客房
          this.onSelectRoom();
          break;
        default:
          //其他
          this.resetOther();
          break;
      }
    },
    resetOther() {
      this.form.MemberCardId = "0";
      this.form.MemberCardNo = "";
      this.form.Password = "";
      this.form.CustomerId = "0";
      this.form.TargetName = "";
      this.form.RoomInfoId = "0";
    },
    //会员卡
    onSelectMember() {
      selectMember({
        height: "90%",
        change: info => {
          this.resetOther();
          this.form.MemberCardId = info.Id;
          this.form.MemberCardNo = info.CardNo;
          this.form.Password = "";
          this.form.TargetName = info.Name;
          this.payType = 1;
        },
      });
    },
    //挂账
    onSelectCustomer() {
      selectUser({
        height: "90%",
        change: info => {
          this.resetOther();
          this.form.CustomerId = info.Id;
          this.form.TargetName = info.Name;
          this.payType = 2;
        },
      });
    },
    onSelectRoom() {
      this.$refs.SelectRoom.show();
    },
    getRoomInfo(info) {
      this.resetOther();
      this.form.RoomInfoId = info.RoomInfoId;
      this.form.TargetName = info.GuestName;
    },
    onSubmit() {
      if (
        Number(this.form.Money) != 0 &&
        (!this.form.AccountItemId || this.form.AccountItemId == 0)
      ) {
        Notify("付款金额不为0，请选择付款方式");
        return false;
      }
      const len = this.orderInfo.DishTables.filter(el => el.OrderStatus != 2)
        .length;
      if (
        this.tableIds.length == len &&
        this.isOnlyPayment == 1 &&
        Number(this.form.Money) != Number(this.orderInfo.UnPayAmount)
      ) {
        Notify("付款金额与待付金额不一致");
        return false;
      }
      if (this.isOnlyPayment == 2 && Number(this.form.Money) == 0) {
        Notify("请填写付款金额");
        return false;
      }
      if (this.form.MemberCardId && this.form.MemberCardId != "0") {
        if (Number(this.form.Money) != 0) {
          MemberPasswordVerify({
            MemberCardId: this.form.MemberCardId,
            money: this.form.Money,
            success: password => {
              this.form.PassWord = password;
              this.onPay();
            },
            error: () => {
              console.log("error");
            },
          });
        } else {
          this.onPay();
        }
      } else {
        this.onPay();
      }
    },
    onPay() {
      let payments = [];
      if (Number(this.form.Money) != 0) {
        payments = [this.form];
      }
      const json = {
        OrderId: this.orderId,
        No: this.orderInfo.No,
        TableIds: this.tableIds,
        Payments: payments,
        IsOnlyPayment: this.isOnlyPayment == 2,
      };
      this.loading = true;
      restaurantManageApi
        .settle(json)
        .then(() => {
          Notify({ type: "success", message: "操作成功" });
          this.loading = false;
          setTimeout(() => {
            this.$router.push({
              name: "restarantManageIndex",
            });
          }, 200);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.submit {
  margin-top: 10px;
}
.settle-box {
  .select-box /deep/.van-cell .van-field__label {
    width: 2.4rem;
  }
}
.settle-method {
  display: flex;
  padding: 10px;
  font-size: 14px;
  label {
    width: 60px;
    text-align: right;
    margin-right: 20px;
  }
  /deep/.van-radio-group {
    display: flex;
    width: 200px;
    justify-content: space-between;
  }
}
.btn-operate {
  display: flex;
  justify-content: space-between;
  padding: 0 17px 10px 31px;
  font-size: 12px;
}
.discount-sec {
  display: flex;
  margin-top: 20px;
  font-size: 14px;
  margin-bottom: 10px;
  label {
    display: inline-block;
    width: 80px;
    text-align: right;
    padding-right: 8px;
    margin-right: 10px;
  }
}
.free-sec {
  margin: 20px 0 10px;
  label {
    display: inline-block;
    width: 90px;
    text-align: right;
    padding-right: 8px;
    margin-right: 10px;
  }
}
</style>
